import { render, staticRenderFns } from "./alert.vue?vue&type=template&id=27c6fa17"
import script from "./alert.vue?vue&type=script&lang=ts"
export * from "./alert.vue?vue&type=script&lang=ts"
import style0 from "./alert.vue?vue&type=style&index=0&id=27c6fa17&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports